import { FC } from 'react';
import { ThemeProvider } from 'styled-components';
import FormProviderWrapper from './FormProvideWrapper';
import { GlobalStyles } from '@sleepunique/components/global/GlobalStyles';
import { OptionsProvider, SleeperDataProvider } from '@sleepunique/context';
import { PageProvider } from '@sleepunique/context/PageContext';
import theme from '@sleepunique/theme';

const Providers: FC = ({ children }) => (
  <PageProvider>
    <SleeperDataProvider>
      <OptionsProvider>
        <ThemeProvider theme={theme}>
          <GlobalStyles />
          <FormProviderWrapper>{children}</FormProviderWrapper>
        </ThemeProvider>
      </OptionsProvider>
    </SleeperDataProvider>
  </PageProvider>
);

export default Providers;
